/* eslint-disable react/prop-types */
import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13.468} height={16} viewBox="1098.982 33 13.468 16" {...props}>
    <path
      d="M1111.825 41.5c.346 0 .625-.28.625-.625v-7.25a.625.625 0 0 0-.625-.624h-9.7l-.018-.001h-1.25a1.877 1.877 0 0 0-1.875 1.876v12.249c0 1.034.841 1.875 1.875 1.875h10.968a.625.625 0 1 0 0-1.25h-10.968a.626.626 0 0 1 0-1.25h10.968c.346 0 .625-.28.625-.625V44a.625.625 0 1 0-1.25 0v1.25h-8.468v-11h8.468v6.625c0 .345.28.625.625.625Zm-10.343 3.75h-.625c-.219 0-.43.038-.625.107V34.876c0-.345.28-.625.625-.625h.625V45.25Zm7.531-8.53a.625.625 0 1 1 0 1.25h-4.093a.625.625 0 1 1 0-1.25h4.093Z"
      fill={props.fill ? props.fill : '#f000'}
      fillRule="evenodd"
      data-name="book (1)"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// src/assets/Book.jsx